import axios from "axios";

const API = axios.create({
  // Make sure this fallback is present!
  baseURL: process.env.REACT_APP_API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});
export default API;
